import type { SubscriptionFilterArgs } from '../../../application'

/**
 * Helper class to address the need to fetch async information
 * in order to map domain entities
 */
export abstract class AsyncMapper<Resource, Domain> {
    private readonly promises: Promise<Domain | null>[] = []

    get values (): Promise<Domain[]> {
        return Promise.all(this.promises).then((results: (Domain | null)[]) => results.filter((r): r is Domain => r !== null))
    }

    protected abstract map (resource: Resource): Promise<Domain | null> | null

    push (resource: Resource): void {
        this.promises.push(Promise.resolve(this.map(resource)))
    }
}

/**
 * Simple extension to add filter support
 */
export abstract class FilteredAsyncMapper<Resource, Domain> extends AsyncMapper<Resource, Domain> {
    constructor (protected readonly filter: SubscriptionFilterArgs, ...args: ConstructorParameters<typeof AsyncMapper<Resource, Domain>>) {
        super(...args)
    }
}
